<form id="form" [formGroup]="form" (ngSubmit)="submit()">
  <div #titleElement mat-dialog-title>
    <button
      type="button"
      mat-icon-button
      mat-dialog-close
      i18n-title
      title="Close">
      <ft-icon name="arrow-left" class="ft-icon--2" />
    </button>
    <div i18n>Activate credit</div>
  </div>
  <div #contentElement mat-dialog-content class="ft-content px-4 px-md-5 pt-3">
    <div
      class="ft-observe-interseting"
      (ftObserveIntersecting)="
        appService.setOverlapped($event, titleElement)
      "></div>
    @if (!loading()) {
      <div class="ft-card ft-card--primary flex-grow-1">
        <div class="ft-card__body ft-card__body--primary">
          <div class="d-flex flex-column flex-md-row gap-3">
            <div class="ft-data-field">
              <div class="ft-data-field__label" i18n>Interest to be earned</div>
              <div
                class="ft-data-field__value d-flex align-items-center justify-content-center gap-1"
                style="font-size: var(--ft-display-font-size-lg)">
                <div>{{ simulation()?.interestEarned | number }}</div>
                <div class="ft-suffix ft-suffix--sm">{{ currencyId() }}</div>
                <ft-icon
                  name="information"
                  class="text-white ft-icon--1 ms-1"
                  #totalTooltip="matTooltip"
                  (click)="totalTooltip.toggle()"
                  i18n-matTooltip
                  [matTooltip]="
                    totalToReceive +
                    ' ' +
                    ((simulation()?.amount || 0) +
                      (simulation()?.interestEarned || 0) | number)
                  " />
              </div>
            </div>
          </div>
        </div>
        <div class="ft-card__body ft-card__body--secondary">
          <div class="d-flex gap-3">
            <div class="ft-data-field flex-grow-1">
              <div class="ft-data-field__label" i18n>Amount</div>
              <div class="ft-data-field__value">
                {{ simulation()?.amount | number }}
              </div>
            </div>
            <div class="ft-separator"></div>
            <div class="ft-data-field flex-grow-1">
              <div class="ft-data-field__label" i18n>Term</div>
              <div class="ft-data-field__value">
                {{ simulation()?.term }}
                {{ simulation()?.frequency?.description }}
              </div>
            </div>
            <div class="ft-separator"></div>
            <div class="ft-data-field flex-grow-1">
              <div class="ft-data-field__label" i18n>Rate</div>
              <div class="ft-data-field__value">{{ simulation()?.rate }}%</div>
            </div>
          </div>
        </div>
      </div>
      <h3 i18n>Beneficiary data</h3>
      <div class="d-flex flex-column gap-2">
        <mat-form-field class="w-100">
          <mat-label i18n>Beneficiary</mat-label>
          <mat-select formControlName="beneficiary" [compareWith]="compareItem">
            <mat-select-trigger>
              {{
                form.get('beneficiary')?.value?.description ||
                  form.get('beneficiary')?.value?.alias ||
                  ''
              }}
            </mat-select-trigger>
            @for (
              beneficiary of beneficiaries.accumulated() ?? [];
              track beneficiary.sequence
            ) {
              <mat-option [value]="beneficiary">
                {{ beneficiary.description }}
              </mat-option>
            }
            <mat-option
              isGranted="btn-add-beneficiary"
              (click)="openBeneficiary()">
              <div class="ft-item">
                <ft-icon name="plus" />
                <div i18n>New beneficiary</div>
              </div>
            </mat-option>
          </mat-select>
          @if (form.get('beneficiary')?.invalid) {
            <mat-error>
              {{ appService.getErrorMessage(form.get('beneficiary')) }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="w-100" isGranted="dwl-group">
          <mat-label i18n>Group</mat-label>
          <mat-select formControlName="group" [compareWith]="compareItem">
            <mat-select-trigger>
              {{ form.get('group')?.value?.description || '' }}
            </mat-select-trigger>
            <mat-option [value]="null" i18n>No group</mat-option>
            @for (group of groups.accumulated() ?? []; track group.sequence) {
              <mat-option [value]="group">{{ group.description }}</mat-option>
            }
            <mat-option
              isGranted="btn-add-group"
              (click)="openGroup()">
              <div class="ft-item">
                <ft-icon name="plus" />
                <div i18n>New group</div>
              </div>
            </mat-option>
          </mat-select>
          @if (form.get('group')?.invalid) {
            <mat-error>
              {{ appService.getErrorMessage(form.get('group')) }}
            </mat-error>
          }
        </mat-form-field>
      </div>
      <h3 class="d-flex align-items-center gap-2">
        <div i18n>General information</div>
      </h3>
      <div class="ft-card" style="width: fit-content; min-width: 100%">
        <table class="ft-table">
          <tbody>
            <tr>
              <th class="text-start" i18n>Amortization table type</th>
              <td>{{ simulation()?.tableType.description }}</td>
            </tr>
            <tr>
              <th class="text-start" i18n>Start date</th>
              <td>{{ simulation()?.effectiveDate | date: 'dd/MM/yyyy' }}</td>
            </tr>
            <tr>
              <th class="text-start" i18n>Pay from</th>
              <td>{{ simulation()?.firstPaymentDate | date: 'dd/MM/yyyy' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <h3 class="mt-4" i18n>Support document</h3>
      <p class="mt-3" i18n>
        If you have a document supporting the offer and you want to attach it to
        the credit, add it from here:
      </p>
      <div class="d-flex flex-column align-items-start gap-2">
        @if (attachedFiles().length > 0) {
          @for (file of attachedFiles(); track file.name) {
            <div class="d-flex gap-2 align-items-center w-50">
              <ft-icon
                name="document--text"
                class="ft-icon--4"
                collection="factoricons-slim" />
              <div>
                <div style="line-height: 1.2">{{ file.name }}</div>
                <small class="text-muted" style="line-height: 1.2">
                  {{ file.size / (1024 * 1024) | number }} MB
                </small>
              </div>
            </div>
          }
        } @else {
          <button
            type="button"
            mat-button
            style="
              border: 2px dashed;
              min-width: 300px;
              padding-block: 6px;
              height: unset;
            "
            class="px-3"
            (click)="attachDocument(simulation())"
            [disabled]="submitting() || attachingFile()">
            @if (!attachingFile()) {
              <div class="ft-item">
                <ft-icon name="upload" class="ft-icon--2" />
                <div i18n>
                  Upload supporting document (Max. {{ attachmentMaxSize() }}MB)
                </div>
              </div>
            } @else {
              <ng-container
                *ngTemplateOutlet="submittingTemplate"></ng-container>
            }
          </button>
        }
        @let simulationEntity = simulation();
        @if (simulation()?.generateFormalDocument && simulationEntity) {
          <button
            type="button"
            mat-stroked-button
            class="px-3"
            style="min-width: 300px"
            [disabled]="submitting() || attachingFile()"
            (click)="simulationService.generateDocument(simulationEntity)">
            <div class="ft-item">
              <ft-icon name="document" class="ft-icon--2" />
              <div i18n>Generate formal document</div>
            </div>
          </button>
        }
      </div>
      <h3 class="mt-4" i18n>Notifications</h3>
      <p i18n>
        We indicate whether you wish to activate any of the following
        notifications so that they are received by the client.
      </p>
      <div class="d-flex flex-column gap-3">
        <mat-checkbox [checked]="true" formControlName="notifyPayment">
          <div i18n>Payment reminder</div>
          <small class="text-muted" i18n>
            If you activate this option, we will send reminders to your
            beneficiary before each installment is due.
          </small>
        </mat-checkbox>
        <mat-checkbox [checked]="true" formControlName="notifyOverduePayment">
          <div i18n>Reminder of overdue payments</div>
          <small class="text-muted" i18n>
            If you activate this option, we will send reminders to your
            beneficiary about the pending installments.
          </small>
        </mat-checkbox>
        <mat-checkbox [checked]="true" formControlName="notifySendingReceipts">
          <div i18n>Sending receipts</div>
          <small class="text-muted" i18n>
            If you activate this option, we will send a notification to your
            beneficiary each time you record a payment on the loan.
          </small>
        </mat-checkbox>
      </div>
    } @else {
      <ft-progress />
    }
    <div
      class="ft-observe-interseting"
      (ftObserveIntersecting)="
        appService.setOverlapped($event, actionsElement)
      "></div>
  </div>
  <div #actionsElement mat-dialog-actions class="justify-content-center">
    <button
      type="submit"
      form="form"
      mat-flat-button
      color="primary"
      [disabled]="form.invalid || submitting() || attachingFile()">
      @if (!submitting()) {
        <span i18n>Submit</span>
      } @else {
        <ng-container *ngTemplateOutlet="submittingTemplate"></ng-container>
      }
    </button>
  </div>
</form>
<ng-template #submittingTemplate>
  <div class="text-center">
    <ft-progress class="ft-progress--2"></ft-progress>
  </div>
</ng-template>
